export const UniverseActionUnavailableReason = {
	ACL_EDITOR_REQUIRED: "ACL_EDITOR_REQUIRED",
	ACL_OWNER_REQUIRED: "ACL_OWNER_REQUIRED",
	LINKED_TO_PORTFOLIO: "LINKED_TO_PORTFOLIO",
	GROUP_UNIVERSE: "GROUP_UNIVERSE",
} as const;

export type UniverseActionUnavailableReason =
	(typeof UniverseActionUnavailableReason)[keyof typeof UniverseActionUnavailableReason];

export const UniverseListAction = {
	delete: "delete",
	share: "share",
	export: "export",
} as const;

export type UniverseListAction = (typeof UniverseListAction)[keyof typeof UniverseListAction];
